// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 76 ? "common" : chunkId) + "." + {"76":"90ffa9f0","335":"0d79ecc7","419":"4f562665","507":"c2b485ef","795":"017d0277"}[chunkId] + ".chunk.js";
};